import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Button, Typography, List, ListItem, ListItemText, Alert } from "@mui/material";
import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import Description from '@mui/icons-material/Description';
import { TypographyTitle, TypographyBoldWrap } from '../style/typography';


const SelectCSVFile = ({ file, setFile, fileName, setFileName, error, setError, selectCSV}) => {

  // バリデーション: ファイル1つ、拡張子がcsvのみ
  const validateFile = (file) => {
    const allowedExtensions = ["csv"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (fileExtension !== "csv") {
      return [
        '申し訳ございません。指定されたファイルはアップロードできません。',
        'CSVファイルのみアップロード可能です。'].join('\n')
    }
    return null;
  };

  // ドロップまたは選択されたファイルの処理
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop: (acceptedFiles, rejectedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const validationError = validateFile(file);

        if (validationError) {
          setError(validationError);
          setFileName("");
        } else {
          setFile(file)
          setFileName(file.name);
          setError("");
        }
      } else {
        setError("1つのCSVファイルのみ選択できます。");
        setFileName("");
      }
    },
    noClick: true,
    multiple: false,
    disabled: selectCSV
  });


  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box
        {...getRootProps()}
        onClick={open}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "80%" ,
          padding: "50px 30px",
          border: "2px dashed #aaa",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: isDragActive ? "#f0f0f0" : "white",
          transition: "background-color 0.3s",
        }}
      >
        <input {...getInputProps()} accept=".csv" disabled={selectCSV} />
        <Description sx={{ fontSize: 40, mr: 3 }} />
        <TypographyBoldWrap>
          {isDragActive
            ? "ファイルをドロップしてください"
            : "ここにファイルをドラッグ＆ドロップ、またはクリックして選択"}
        </TypographyBoldWrap>
      </Box>

      {fileName && !error && (
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontWeight: "bold",
            color: "#0A7CB7",
            textAlign: "center",
          }}
        >
          アップロードされたファイル: {fileName}
        </Typography>
      )}

      {error && (
        <Alert
          severity="error"
          sx={{
            position: "fixed",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            width: "auto",
          }}
        >
          {error}
        </Alert>
      )}
  </Box>
  );
};
  
export default SelectCSVFile;
